import { contract } from '../../actions/constant';

const { GET_CONTRACT_COUNT_REQUEST, GET_CONTRACT_COUNT_SUCCESS, GET_CONTRACT_COUNT_FAILURE } =
  contract;

const initialState: object = {
  response: [],
};
export const getContractCountReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_CONTRACT_COUNT_REQUEST: {
      return {
        ...state,
        response: action.payload,
      };
    }

    case GET_CONTRACT_COUNT_SUCCESS:
      return {
        ...state,
        response: action.payload,
      };

    case GET_CONTRACT_COUNT_FAILURE:
      return initialState;

    default:
      return state;
  }
};
